/* Northsheep — keep the size pills on a product card to TWO ROWS.
 *
 * Liquid caps the COUNT (5 desktop / 3 mobile), which is not the same thing as
 * the height: "6.5 (hand approx. 18 cm)" is three times the width of "XL", so
 * five of those stack five rows deep and the card grows taller than the photo
 * above it. Rows can only be measured in the browser, so they are measured
 * here, and what does not fit becomes a "+N".
 *
 * READ EVERYTHING, THEN WRITE EVERYTHING — same rule as the swatch fitter
 * (ns-card-variant-swatches.js), and for the same reason. The first version
 * hid the last pill, re-measured, hid another, re-measured… which forces a
 * synchronous layout per step: 778ms for 16 rows on a 96-card page, and the
 * whole page felt stuck because every grid change re-ran it. Now each pill's
 * width is read once, the rows are worked out with arithmetic, and the
 * display writes happen at the end: two layouts for the page instead of
 * hundreds.
 */
(function () {
  if (window.__nsSizePillsLoaded) return;
  window.__nsSizePillsLoaded = true;

  var MAX_ROWS = 2;

  /* Calm cards (Theme settings -> "Calm cards", owner 3 Oct 2026: the sizes
     as one line) keep the row to ONE line; the rest go into the "+N". Asked
     per row, not of the page: Recently viewed and the favourites page build
     their own cards, without the calm row, and keep two lines. */
  function rowsFor(box) {
    var card = box && box.closest && box.closest('.card-wrapper');
    return card && card.querySelector('.ns-calm-row') ? 1 : MAX_ROWS;
  }

  /* How many of these widths fit in maxRows rows, and does the chip fit with
     them? Pure arithmetic — no DOM. Returns the number of pills to show. */
  function howManyFit(widths, gap, avail, chipW, total, maxRows) {
    var MAX_ROWS = maxRows || 2;
    function rowsNeeded(list, extra) {
      var rows = 1;
      var used = 0;
      for (var i = 0; i < list.length; i++) {
        var w = list[i];
        var next = used === 0 ? w : used + gap + w;
        if (next > avail && used > 0) {
          rows++;
          used = w;
        } else {
          used = next;
        }
        if (rows > MAX_ROWS) return rows;
      }
      if (extra > 0) {
        var withChip = used === 0 ? extra : used + gap + extra;
        if (withChip > avail) rows++;
      }
      return rows;
    }

    // Everything, no chip needed: the happy case for a short size list.
    if (widths.length === total && rowsNeeded(widths, 0) <= MAX_ROWS) return widths.length;

    for (var n = widths.length; n >= 1; n--) {
      if (rowsNeeded(widths.slice(0, n), chipW) <= MAX_ROWS) return n;
    }
    return 1; // never leave a card with no size at all
  }

  function fitAll(force, root) {
    var boxes = (root || document).querySelectorAll('.ns-card-sizes[data-total]');
    if (!boxes.length) return;
    var jobs = [];
    var i;

    /* 1. READ: which rows need doing, and how much room each has.
       This pass comes FIRST and touches nothing, because the reset in pass 2
       makes every pill visible again: doing that to a row we then skip left
       the card showing all eight sizes and a stale "+0" chip. */
    for (i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var pills = Array.prototype.slice.call(box.querySelectorAll('.ns-card-sizes__pill'));
      if (!pills.length) continue;
      var avail = box.clientWidth;
      /* Nothing measurable: a closed drawer, a hidden tab, a window that is
         not on screen. Those report 0 — or a couple of pixels, which is worse,
         because it looks like a real width and every pill then "overflows".
         The narrowest real card is about 150px, so anything under 60 is not a
         card. Leave those rows alone; resize runs again when they get a
         width. */
      if (avail < 60) continue;
      if (!force && box.__nsFitW === avail) continue;
      jobs.push({
        box: box,
        pills: pills,
        avail: avail,
        total: parseInt(box.getAttribute('data-total'), 10) || pills.length,
      });
    }
    if (!jobs.length) return;

    // 2. WRITE: clean slate on those rows, so a card that got wider grows back.
    for (i = 0; i < jobs.length; i++) {
      var j = jobs[i];
      var chip = j.box.querySelector('.ns-card-sizes__more--js');
      if (!chip) {
        chip = document.createElement('span');
        chip.className = 'ns-card-sizes__more ns-card-sizes__more--js';
        j.box.appendChild(chip);
      }
      j.chip = chip;
      j.box.classList.add('ns-card-sizes--js');
      // Natural widths for the read below — see ns-card-size-pills.css.
      j.box.classList.add('ns-card-sizes--measuring');
      for (var p = 0; p < j.pills.length; p++) j.pills[p].style.display = '';
      chip.textContent = '+' + (j.total - j.pills.length);
      chip.style.display = '';
    }

    // 3. READ: every pill's width, the chip's width and the gap.
    for (i = 0; i < jobs.length; i++) {
      var job2 = jobs[i];
      var cs = getComputedStyle(job2.box);
      job2.gap = parseFloat(cs.columnGap || cs.gap) || 0;
      /* Kept for a grid-based row, should one ever come back: there "how many
         fit" is just the column count. Every design ships as flex today, so
         this stays 0 and the widths below do the work. */
      job2.cols = 0;
      if (cs.display === 'grid') {
        var tracks = (cs.gridTemplateColumns || '').trim().split(/\s+/);
        job2.cols = tracks.length && tracks[0] !== 'none' ? tracks.length : 0;
      }
      job2.widths = [];
      for (var k = 0; k < job2.pills.length; k++) job2.widths.push(job2.pills[k].offsetWidth);
      job2.chipW = job2.chip.offsetWidth;
    }

    // 4. WRITE: show what fits, count the rest.
    for (i = 0; i < jobs.length; i++) {
      var job = jobs[i];
      var show;
      if (job.cols > 0) {
        var slots = job.cols * rowsFor(job.box);
        // The "+N" takes a cell of its own, so it only costs one when it shows.
        show = job.total <= slots ? job.pills.length : Math.max(1, slots - 1);
        if (show > job.pills.length) show = job.pills.length;
      } else {
        show = howManyFit(job.widths, job.gap, job.avail, job.chipW, job.total, rowsFor(job.box));
      }
      for (var m = 0; m < job.pills.length; m++) {
        job.pills[m].style.display = m < show ? '' : 'none';
      }
      job.box.classList.remove('ns-card-sizes--measuring');
      var hidden = job.total - show;
      job.chip.textContent = '+' + hidden;
      job.chip.style.display = hidden > 0 ? '' : 'none';
      job.box.__nsFitW = job.avail;
    }
  }

  var timer = null;
  var pendingForce = false;
  function schedule(force) {
    if (force) pendingForce = true;
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      /* A card being dragged in curate re-inserts nodes every frame while no
         row changes width. Wait for the finger to come up. */
      if (document.body.classList.contains('ns-fav-sorting')) {
        schedule(false);
        return;
      }
      var f = pendingForce;
      pendingForce = false;
      fitAll(f);
    }, 120);
  }

  /* Was the pills' font already in place for the parse-time fit below? Only
     then is that fit final. */
  var firstFitFontsReady = false;
  /* ...and if it was not: did a pill's width actually change by DOMContentLoaded?
     The fonts are font-display: optional, so a font that missed its moment is
     never swapped in and the rows are already right; the full refit (~460 ms at
     4x CPU on a first visit) runs only when the width moved (4 Oct 2026 audit). */
  var firstPillWidth = -1;
  function pillWidth() {
    var p = document.querySelector('.ns-card-sizes__pill');
    return p ? p.getBoundingClientRect().width : 0;
  }
  function fontsReady() {
    var pill = document.querySelector('.ns-card-sizes__pill');
    if (!pill || !document.fonts || !document.fonts.check) return true;
    var cs = getComputedStyle(pill);
    try {
      return document.fonts.check(cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily);
    } catch (e) {
      return true;
    }
  }

  function init() {
    /* ONE PASS, NOT TWO (audit B4, 2 Oct 2026). The collection grid fits every
       row while the page is still parsing (below); refitting all 96 again here
       cost ~460 ms at 4x CPU and changed nothing. A row is refitted only if
       its width changed since (fitAll(false) checks that) - or all of them, as
       before, when the font had not arrived for that first fit. */
    fitAll(!firstFitFontsReady && (firstPillWidth < 0 || pillWidth() !== firstPillWidth));
    /* Width changes only: a phone toolbar collapsing mid-scroll fires resize
       with only the height changed, and each one refitted every card's row
       (see the same guard in ns-card-variant-swatches.js). */
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      schedule(true);
    }, { passive: true });
    document.addEventListener('ns:cards-appended', function () {
      schedule(false);
    });
    if ('MutationObserver' in window) {
      var obs = new MutationObserver(function () {
        schedule(false);
      });
      /* NOT JUST THE COLLECTION GRID (owner, 20 Sep 2026).
         "You may also like" and the related rows fill themselves in AFTER the
         page has loaded - <product-recommendations> replaces its own
         innerHTML, and the scrolling rows build their track from JS. Watching
         only .product-grid meant those cards were never measured, so the row
         cap never applied and a product with three long size names stacked
         three deep. Same roots ns-portrait-fill.js watches, for the same
         reason. */
      /* #ProductGridContainer, not .product-grid. Filtering and sorting
         replace that container's innerHTML wholesale (Section Rendering API),
         so the .product-grid this observer was bound to is destroyed with it
         and the observer stops firing — the cards come back uncapped, three
         rows deep and with no "+N" (owner, 20 Sep 2026). The container itself
         survives every re-render, so watching that keeps working. */
      var roots = document.querySelectorAll(
        '#ProductGridContainer, .product-grid, product-recommendations, .ns-srow__track, .ns-product-related'
      );
      for (var i = 0; i < roots.length; i++) obs.observe(roots[i], { childList: true, subtree: true });
    }
  }

  /* FIT BEFORE THE FIRST PAINT WHEN THE CARDS ARE ALREADY HERE (owner, 23 Sep
     2026: coming back to a collection, "it jumps down a bit and then up to
     position", worse the further down the page).

     Before this script has run, a desktop card shows at most five sizes on
     one line; fitted, it shows up to eight on two. So every card with more
     than a line of sizes grew 34px AFTER the page was on screen. Measured on
     a return near the third promo tile: the first row grew 544 → 578, so the
     page first appeared 32px short above the reading position, and the
     restore then had to move it — that correction was the jump. Each such row
     above the reading position adds its own 34px, which is why it got worse
     further down.

     The collection grid now loads this file synchronously, straight after
     its cards (main-collection-product-grid.liquid), so this fits them while
     the document is still parsing — before anything is painted, and before
     the browser restores the scroll position into it. The listeners still
     wait for DOMContentLoaded, and on every other page the deferred copy in
     theme.liquid behaves exactly as before. */
  if (document.readyState === 'loading') {
    if (document.querySelector('.ns-card-sizes[data-total]')) {
      fitAll(true);
      firstFitFontsReady = fontsReady();
      if (!firstFitFontsReady) firstPillWidth = pillWidth();
    }
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* A root limits the pass to the rows inside it: the Enlarge card refits
     its own row on open and close, not all 96 on the page (audit, 2 Oct 2026). */
  window.nsFitSizePills = function (root) {
    fitAll(true, root && root.querySelectorAll ? root : null);
  };
})();
